import React from 'react';
import PropTypes from 'prop-types';
import { VideoCameraIcon } from '@heroicons/react/24/solid';
import { IconCalendar } from '../Icons';

const CallAppointmentIcon = ({ canceled, missed }) => (
  <div className={`w-16 h-16 relative ${missed ? 'text-slate-400' : 'text-blue-600'}`}>
    <IconCalendar size="12" className="fill-current" />
    <VideoCameraIcon className="fill-current absolute bottom-0 h-11 w-11 right-0 mr-1 mb-1" />
    <div
      className={`h-4 w-4 absolute bottom-0 right-0 mr-5 mb-4 ${
        missed ? 'bg-slate-400' : 'bg-blue-600'
      }`}
    />
    {canceled && (
      <>
        <hr
          className="h-px border-t-1 bg-red-600 w-full absolute bottom-0 mb-8 border-red-600"
          style={{ transform: 'rotate(-45deg)' }}
        />
        <hr
          className="h-px border-t-1 bg-red-600 w-full absolute bottom-0 mb-8 border-red-600"
          style={{ transform: 'rotate(45deg)' }}
        />
      </>
    )}
  </div>
);

CallAppointmentIcon.propTypes = {
  canceled: PropTypes.bool,
  missed: PropTypes.bool,
};

CallAppointmentIcon.defaultProps = {
  canceled: false,
  missed: false,
};

export default CallAppointmentIcon;
